import { render, staticRenderFns } from "./PackagesSearchInput.vue?vue&type=template&id=30a5546c&scoped=true"
import script from "./PackagesSearchInput.vue?vue&type=script&lang=js"
export * from "./PackagesSearchInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a5546c",
  null
  
)

export default component.exports